export class MissingTokenError extends Error {}
export class FronteggSignupError extends Error {}
export class FronteggSigninError extends Error {}
